import userStore from "../stores/UserStore";

export async function handleLogin(accessToken) {
  userStore.setUserToken(accessToken);
}
